// extracted by mini-css-extract-plugin
export default {"modal":"modal___V9sCD","sumsubVerifyModalLoading":"sumsubVerifyModalLoading___AW9Ol"};